var $ = require('jquery');
let listOfPageThatWasClicked = null;

$('body').on('click', '.facetwp-page', function() {
    listOfPageThatWasClicked = $(this).closest('.pagination').prev();
})

$(document).on('facetwp-loaded', function(e) {
    let initFacetWPLoad = window.location.search == '' ? false : true;
    if ( initFacetWPLoad == false ) {
        initFacetWPLoad = true;
    } else {
        if ( window.location.search ) {
            let listTop = $('.post-list').offset().top - $('.site-header__primary').outerHeight(true) - 80;
            window.scrollTo({ top: listTop, behavior: 'smooth' });
        }
        if( listOfPageThatWasClicked !== null ) {
            let listTop = listOfPageThatWasClicked.offset().top - $('.site-header__primary').outerHeight(true);
            window.scrollTo({ top: listTop, behavior: 'smooth' });
        }
    }

    $('.facetwp-facet').each(function() {
        if ( !$('.facetwp-date-wrap').length ) {
            var facet = $(this);
            var facet_type = facet.attr('data-type');
            if (facet_type == 'date_range') {
                facet.find('.facetwp-date').wrap('<div class="facetwp-date-wrap"></div>');
    
                $('.facetwp-date-wrap').each(function() {
                    var facet_label = $('<label class="facetwp-date-label">');
                    facet_label.html($(this).find('.facetwp-date').attr('placeholder'));
                    // facet_label.insertBefore( $(this).find('input.facetwp-date') )
                })
            }
        }
    });
});
